// @flow
import { themeStyle } from '../colorPalettes'

import { lightTheme } from './lightTheme'
import { darkTheme } from './darkTheme'

import type { ThemeType } from '..'

const miplayThemeName = 'miplay'

export const themeMiplay: ThemeType = {
  name: miplayThemeName,
  getThemeVariation: (themeVariation: string) => {
    switch (themeVariation) {
      case themeStyle.light:
        return lightTheme
      case themeStyle.dark:
        return darkTheme
      default:
        return lightTheme
    }
  },
}
